module.exports = __webpack_public_path__ + "img/bdd892c.svg";